import { render, staticRenderFns } from "./filingLetter.vue?vue&type=template&id=22a9b623"
import script from "./filingLetter.vue?vue&type=script&lang=js"
export * from "./filingLetter.vue?vue&type=script&lang=js"
import style0 from "./filingLetter.vue?vue&type=style&index=0&id=22a9b623&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports